const initialState = {
  allProcess:[],
  activesProcess: [],
  historicalProcess: [],
  selectedProcess: null,
  saving: false,
  loading: false,
  error: null,
  stages:{
    data:[],
    loading:[],
    error:null
  }
};

const processReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_PROCESSES_REQUEST':
    case 'FETCH_PROCESS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'LOAD_PROCESSES_SUCCESS':
      return {
        ...state,
        allProcess: action.payload,
        loading: false,
      };
    case 'FETCH_PROCESS_SUCCESS':
      return {
        ...state,
        loading: false,
        activesProcess: action.payload.actives,
        historicalProcess: action.payload.historical,
      };
    case 'LOAD_PROCESSES_FAIL':
    case 'FETCH_PROCESS_FAIL':
      return { ...state, loading: false, error: action.payload };

    case 'SAVE_PROCESS_REQUEST':
      return { ...state, saving: true, error: null };
    case 'SAVE_PROCESS_SUCCESS':
      return { ...state, saving: false, error: null };
    case 'SAVE_PROCESS_FAIL':
      return { ...state, saving: false, error: action.payload };
    
      case 'SAVE_PROCESS_REQUEST':
      return { ...state, saving: true, error: null };
    case 'SAVE_PROCESS_SUCCESS':
      return { ...state, saving: false, error: null };
    case 'SAVE_PROCESS_FAIL':
      return { ...state, saving: false, error: action.payload };
    
    case 'UPDATE_PROCESS_STATE_REQUEST':
      return { ...state, saving: true, error: null };
    case 'UPDATE_PROCESS_STATE_SUCCESS':
      return { ...state, saving: false, error: null };
    case 'UPDATE_PROCESS_STATE_FAIL':
      return { ...state, saving: false, error: action.payload };
    
    case 'SET_SELECTED_PROCESS':
      return { ...state, selectedProcess: action.payload };

    case 'LOAD_STAGES_REQUEST':
      return { ...state, stages: { ...state.stages, loading: true, error: null },};
    case 'LOAD_STAGES_SUCCESS':
      return { ...state, stages: { ...state.stages, loading: false, error: null, data: action.payload },};
    case 'LOAD_STAGES_FAIL':
      return { ...state, stages: { ...state.stages, loading: false, error: action.payload },};

    default:
      return state;
  }
};

export default processReducer;
